import { apiClient } from '@/libs/api'

export type DcsSiteDisplaySettingQuery = {
  tenantKey: string
  dcId: number
}

export const fetchSiteDisplaySetting = async (
  { tenantKey, dcId }: DcsSiteDisplaySettingQuery,
  signal?: AbortSignal
) => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .dcs._id(dcId)
    .site_display_setting.$get({
      config: {
        signal
      }
    })
  return data
}
